import { render, staticRenderFns } from "./pufaAccountAgreement.vue?vue&type=template&id=7386df0a&scoped=true"
import script from "./pufaAccountAgreement.vue?vue&type=script&lang=js"
export * from "./pufaAccountAgreement.vue?vue&type=script&lang=js"
import style0 from "./pufaAccountAgreement.vue?vue&type=style&index=0&id=7386df0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7386df0a",
  null
  
)

export default component.exports